import { ItemClass } from "../../common/constants";
import { ProductionRate } from "../../domain/productionRate";
import { Dispatch } from "react"
import { CatalogItemFormValues } from "./catalogItemModel";

export type Action =
  | { type: 'RESET_FORM', model: CatalogItemFormValues }
  | { type: 'NAME_UPDATED', name: string }
  | { type: 'SKU_UPDATED', sku: string }
  | { type: 'CLASS_UPDATED', classId: ItemClass }
  | { type: 'PRODUCTION_RATE_UPDATED', productionRate?: ProductionRate }
  | { type: 'UNITS_UPDATED', units?: string }
  | { type: 'COST_UPDATED', cost: number }
  | { type: 'TAXABLE_UPDATED', taxable: boolean }
  | { type: 'OVERTIME_FACTOR_UPDATED', overtimeFactor?: number }
  | { type: 'UNBILLABLE_PERCENT_UPDATED', unbillablePercent?: number }
  | { type: 'LABOR_BURDEN_UPDATED', laborBurden?: number }
  | { type: 'CUSTOM_PRICE_UPDATED', customPrice?: number | null }
  | { type: 'CUSTOM_PROFIT_MARGIN_UPDATED', customProfitMargin?: number }
  | { type: 'DESCRIPTION_UPDATED', description?: string }
  | { type: 'CATEGORIES_UPDATED', categories: string[] }
  | { type: 'TAGS_UPDATED', tags: string[] }

export const reducer = (state: CatalogItemFormValues, action: Action): CatalogItemFormValues => {
  switch (action.type) {
    case 'RESET_FORM':
      return action.model
    case 'NAME_UPDATED':
      return { ...state, name: action.name }
    case 'SKU_UPDATED':
      return { ...state, sku: action.sku }
    case 'CLASS_UPDATED':
      return { ...state, itemClass: action.classId }
    case 'PRODUCTION_RATE_UPDATED':
      return {
        ...state,
        rateInstallationQuantity: action.productionRate?.rateInstallationQuantity,
        ratePerUnits: action.productionRate?.ratePerUnits,
        rateUsageQuantity: action.productionRate?.rateUsageQuantity,
      }
    case 'UNITS_UPDATED':
      return { ...state, units: action.units }
    case 'COST_UPDATED':
      return { ...state, cost: action.cost }
    case 'TAXABLE_UPDATED':
      return { ...state, taxable: action.taxable }
    case 'OVERTIME_FACTOR_UPDATED':
      return { ...state, overtimeFactor: action.overtimeFactor }
    case 'UNBILLABLE_PERCENT_UPDATED':
      return { ...state, unbillablePercent: action.unbillablePercent }
    case 'LABOR_BURDEN_UPDATED':
      return { ...state, laborBurden: action.laborBurden }
    case 'CUSTOM_PRICE_UPDATED':
      return { ...state, customPrice: action.customPrice }
    case 'CUSTOM_PROFIT_MARGIN_UPDATED':
      return { ...state, customProfitMargin: action.customProfitMargin }
    case 'DESCRIPTION_UPDATED':
      return { ...state, description: action.description }
    case 'CATEGORIES_UPDATED':
      return { ...state, categories: action.categories }
    case 'TAGS_UPDATED':
      return { ...state, tags: action.tags }
    default:
      return state
  }
}

export const resetForm = (dispatch: Dispatch<Action>) => (model: CatalogItemFormValues) => dispatch({ type: 'RESET_FORM', model })
export const updateName = (dispatch: Dispatch<Action>) => (name: string) => dispatch({ type: 'NAME_UPDATED', name })
export const updateSku = (dispatch: Dispatch<Action>) => (sku: string) => dispatch({ type: 'SKU_UPDATED', sku })
export const updateClass = (dispatch: Dispatch<Action>) => (classId: ItemClass) => dispatch({ type: 'CLASS_UPDATED', classId })
export const updateProductionRate = (dispatch: Dispatch<Action>) => (productionRate?: ProductionRate) => dispatch({ type: 'PRODUCTION_RATE_UPDATED', productionRate })
export const updateUnits = (dispatch: Dispatch<Action>) => (units?: string) => dispatch({ type: 'UNITS_UPDATED', units })
export const updateCost = (dispatch: Dispatch<Action>) => (cost: number) => dispatch({ type: 'COST_UPDATED', cost })
export const updateTaxable = (dispatch: Dispatch<Action>) => (taxable: boolean) => dispatch({ type: 'TAXABLE_UPDATED', taxable })
export const updateOvertimeFactor = (dispatch: Dispatch<Action>) => (overtimeFactor?: number) => dispatch({ type: 'OVERTIME_FACTOR_UPDATED', overtimeFactor })
export const updateUnbillablePercent = (dispatch: Dispatch<Action>) => (unbillablePercent?: number) => dispatch({ type: 'UNBILLABLE_PERCENT_UPDATED', unbillablePercent })
export const updateLaborBurden = (dispatch: Dispatch<Action>) => (laborBurden?: number) => dispatch({ type: 'LABOR_BURDEN_UPDATED', laborBurden })
export const updateCustomPrice = (dispatch: Dispatch<Action>) => (customPrice?: number | null) => dispatch({ type: 'CUSTOM_PRICE_UPDATED', customPrice })
export const updateCustomProfitMargin = (dispatch: Dispatch<Action>) => (customProfitMargin?: number) => dispatch({ type: 'CUSTOM_PROFIT_MARGIN_UPDATED', customProfitMargin })
export const updateDescription = (dispatch: Dispatch<Action>) => (description?: string) => dispatch({ type: 'DESCRIPTION_UPDATED', description })
export const updateCategories = (dispatch: Dispatch<Action>) => (categories: string[]) => dispatch({ type: 'CATEGORIES_UPDATED', categories })
export const updateTags = (dispatch: Dispatch<Action>) => (tags: string[]) => dispatch({ type: 'TAGS_UPDATED', tags })

